import React, { useEffect, useState } from "react";
import TextCapsule from "../../../../common/TextCapsule";
import { nextCard } from "../../../../redux/slices/CardSlices";
import { Button } from "@mui/material";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import { getRmTypes } from "../../../../services/yourAssets/goldRawMaterialServices";
import { useTranslation } from "react-i18next";

const AddList = (props) => {
  const { t } = useTranslation();
  const [rmTypesList, setRmTypesList] = useState([]);
  const { handleSetProperties, selectedProperties, nextCard } = props;
  const handleClickOnList = (obj) => {
    handleSetProperties(obj);
  };
  const handleClick = () => {
    if (selectedProperties?.length) {
      nextCard();
    }
  };
  useEffect(() => {
    getRmTypesList();
  }, []);

  const getRmTypesList = async () => {
    let apiResult = await getRmTypes();
    if (apiResult.success) {
      let rmTypes = apiResult.payLoad.map((el) => {
        return {
          id: el.materialCategoryId,
          name: el.name,
          translationKey: el?.translationKey || "",
        };
      });
      setRmTypesList(rmTypes);
    }
  };

  const selection = rmTypesList.map((el) => {
    return (
      <TextCapsule
        key={el.id}
        title={t(el.translationKey)}
        click={() => handleClickOnList(el)}
        width="100px"
        minWidth="auto"
        padding="5px 0px"
        textAlign="center"
        bgColor={
          selectedProperties.some((item) => {
            if (item.id === el.id) {
              return true;
            }
            return false;
          })
            ? "color.magentaLight2"
            : "color.lightGrey"
        }
        color={
          selectedProperties.some((item) => {
            if (item.id === el.id) {
              return true;
            }
            return false;
          })
            ? "color.black"
            : "color.dimGrey"
        }
      />
    );
  });
  return (
    <div className="gold-raw-list-container">
      <Grid
        container
        sx={{
          background: "white",
          boxShadow:
            "  0px 2px 4px -1px rgb(0 0 0 / 3%), 0px 4px 5px 0px rgb(0 0 0 / 3%), 0px 1px 10px 0px rgb(0 0 0 / 3%)",
          padding: "15px 17px 20px 17px",
          borderRadius: "5px",
          maxWidth: "480px",
        }}
      >
        {selection}
        <Grid
          item
          lg={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            sx={{
              backgroundColor: `${
                !selectedProperties?.length
                  ? "color.dimGrey"
                  : "color.magentaMid2"
              }`,
              color: "color.white",
              padding: "5px 20px",
              borderRadius: "15px",
              marginTop: ".5rem",
              marginRight: ".8rem",
              border: "none",
              textTransform: "initial",
              "&:hover": {
                backgroundColor: "color.magentaLight2",
                boxShadow: "none",
              },
            }}
            disabled={!selectedProperties?.length}
            onClick={() => handleClick()}
          >
            {t("add-to-list")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
  };
}

export default connect(null, mapDispatchToProps)(AddList);
